import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import swal from 'sweetalert';
import { sessionService } from '../../services/SessionService';
import ImageUploader from "react-images-upload";

interface EditInstallationProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class EditInstallation extends React.Component<EditInstallationProps> {

    @observable private contract: any;
    @observable private isLoaded = false;
    @observable private redirect = false;
    @observable private canContinue = false;
    @observable private validationErrors: string[] = [
        "notes_installation",
        "mac"
    ];
    @observable private sectorials: any = [];
    @observable private usedIps: any = [];
    @observable private availableIps: any = [];
    @observable private usedPorts: any = [];
    @observable private availablePorts: any = [];
    @observable private hasPorts: boolean = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        http.get(`/api/contract/read/${id}`).then((response) => {
            this.contract = response.data;
            this.contract.sectorial_id = "";
            this.contract.ip = "";
            this.contract.mac = "";
            this.contract.port = "";
        })
            .then(() => {
                http.get(`/api/sectorial/available`).then((response) => {
                    this.sectorials = response.data.response;
                    this.isLoaded = true;
                });
            })
            .catch(() => {
                toast.error("Error cargando contrato");
            });
    }

    private handleSectorialChange = () => {
        if (this.contract.sectorial_id === "") {
            this.availableIps = [];
            this.contract.ip = "";
            this.availablePorts = [];
            this.contract.port = "";
            this.hasPorts = false;
            return;
        }
        this.contract.port = "";
        const request = JSON.stringify({
            id: this.contract.sectorial_id
        });
        http.post(`/api/sectorial/ips`, request).then((response) => {
            this.usedIps = response.data.response;
            this.generateAvailableIps();
        }).catch(() => {
            this.usedIps = [];
            this.generateAvailableIps();
        })
        http.post(`/api/sectorial/ports`, request).then((response) => {
            // El endpoint devuelve los puertos disponibles directamente en response
            const availablePortsFromApi = response.data.response || [];
            this.availablePorts = availablePortsFromApi.map((port: any) => ({
                id: String(port),
                name: String(port)
            }));
            // Si hay puertos disponibles y no hay uno seleccionado, seleccionar el primero
            if (this.availablePorts.length > 0 && (!this.contract.port || this.contract.port === "")) {
                this.contract.port = this.availablePorts[0].id;
            }
            // Verificar si el sectorial tiene puertos
            const sectorial = this.sectorials.find((x: any) => x.id === this.contract.sectorial_id);
            this.hasPorts = sectorial && sectorial.ports_number && Number(sectorial.ports_number) > 0;
        }).catch(() => {
            this.availablePorts = [];
            this.hasPorts = false;
        })
    }

    private generateAvailableIps = () => {
        const sectorial = this.sectorials.find((x: any) => {
            return x.id === this.contract.sectorial_id
        });
        this.availableIps = [];
        for (let i = Number(sectorial.range_start); i <= Number(sectorial.range_end); i++) {
            if (this.usedIps.indexOf(`${sectorial.ip_start}.${i}`) === -1) {
                this.availableIps.push({
                    id: `${sectorial.ip_start}.${i}`,
                    name: `${sectorial.ip_start}.${i}`
                });
            }
        }
        if (this.availableIps.length > 0) {
            this.contract.ip = this.availableIps[0].id;
            this.setValidation(false, "ip");
        }
    }

    private generateAvailablePorts = () => {
        // Esta función ya no es necesaria porque los puertos disponibles
        // vienen directamente del API. Se mantiene por compatibilidad pero
        // la lógica principal está en handleSectorialChange.
        // Si el puerto actual del contrato no está en availablePorts, agregarlo
        if (this.contract.port && this.contract.port !== "") {
            const currentPortStr = String(this.contract.port);
            const portExists = this.availablePorts.find((p: any) => p.id === currentPortStr);
            if (!portExists) {
                this.availablePorts.push({
                    id: currentPortStr,
                    name: currentPortStr
                });
            }
        }
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.contract[name] = value;

        if (name === "sectorial_id") {
            this.handleSectorialChange();
        }
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onDrop2 = (pictureFiles: any) => {
        if (pictureFiles.length > 0) {
            pictureFiles.forEach((file: any, index: number) => {
            let formData = new FormData();
            formData.append('id', this.contract.id);
            formData.append('file', pictureFiles[index], pictureFiles[index].name);
            http.post('/api/contract/uploadImage', formData)
                .then((res) => {
                    this.canContinue = true;
                    toast.success("Imagen subida con exito");
                }).catch(() => {
                    toast.error("Error subiendo imagen");
                });
            });
            
        }
    }


    private onSubmit = (): void => {
        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        if (!this.canContinue) {
            toast.error("Debes subir al menos una foto");
            return;
        }

        //si el id del contrato empieza con w eliminar la w
        if (this.contract.id.toString().startsWith("W")) {
            this.contract.id = this.contract.id.substring(1);
        }

        // eslint-disable-next-line
        this.contract.reference_phone = this.contract.reference_phone.replace(/\-/g, '');
        this.contract.installed_by = sessionService.getUserInfo().id;

        swal({
            title: "Confirmar ación",
            text: "¿Quieres guardar tus cambios?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willSave => {
                if (willSave) {
                    http.post(`/api/contract/install`, JSON.stringify(this.contract))
                        .then(() => {
                            toast.success(`Instalación guardada`);
                            this.redirect = true;
                        }).catch((error) => {
                            if (Array.isArray(error)) {
                                error.forEach((val) => {
                                    toast.error(val);
                                })
                            } else {
                                toast.error(error);
                            }
                        });
                }
            });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }

        if (this.redirect) {
            return <Redirect to="/instalaciones" />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Instalar Contrato #{this.contract.id}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../../instalaciones`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Cliente</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.client_name}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Telefono Cliente</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.client_phone}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Referencia</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.reference}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Teléfono de Referencia</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.reference_phone}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Relación de Referencia</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.reference_relationship}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Dirección</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.address_street}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Colonia</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.address_colonia}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Número Interior</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.address_interior}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Número Exterior</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.address_exterior}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Fecha de corte</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.cutoff_date}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Paquete contratado</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.package_name}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Forma de cobro</label>
                                    <div className="col-sm-8">
                                        <strong>{this.contract.payment_type}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Datos de Instalación</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <label className="col-sm-4">IP</label>
                                    <div className="col-sm-8">
                                        <h3>{this.contract.ip}</h3>
                                    </div>
                                </div>
                                <InputForm
                                    name="mac"
                                    label="Mac Adress"
                                    value={this.contract.mac}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="sectorial_id"
                                    label="Sectorial"
                                    value={this.contract.sectorial_id}
                                    setValidation={this.setValidation}
                                    required={false}
                                    onChange={this.handleChange}
                                    options={this.sectorials}
                                    type="select"
                                />
                                <InputForm
                                    name="ip"
                                    label="Elegir otra IP"
                                    value={this.contract.ip}
                                    setValidation={this.setValidation}
                                    required={false}
                                    onChange={this.handleChange}
                                    options={this.availableIps}
                                    type="select"
                                />
                                {this.hasPorts &&
                                <InputForm
                                    name="port"
                                    label="Puerto"
                                    value={this.contract.port}
                                    setValidation={this.setValidation}
                                    required={false}
                                    onChange={this.handleChange}
                                    options={this.availablePorts}
                                    type="select"
                                />
                                }
                                <InputForm
                                    name="notes_installation"
                                    label="Notas (Max: 255 caracteres)"
                                    value={this.contract.notes_installation}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="textarea"
                                    maxLength={255}
                                />
                                <ImageUploader
                                    withIcon={true}
                                    buttonText="Subir Imagenes"
                                    onChange={this.onDrop2}
                                    imgExtension={[".jpg", "jpeg"]}
                                    maxFileSize={5242880}
                                    withPreview={true}
                                    label="Sube imagenes de la instalación"
                                />
                                <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Guardar datos de instalación</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}